// REAL Google reviews — paste your top reviews here from your Google Business
// Profile (https://share.google/rOYxiTk24hlZ74p3H). The carousel will render
// these automatically. Leave the list EMPTY to hide the carousel and show a
// "be the first to review" CTA instead.

export const GOOGLE_REVIEWS = [
  {
    name: "Marion Gillon",
    rating: 5,
    date: "3 months ago",
    quote:
      "Excellent service, not just pool cleaning but many extras. Will do anything that's needed when they come to make your pool ready for swimming. Professional, fixed mechanical problems without being asked. Local business, always the same people so you can get to know them.",
  },
  {
    name: "Jess Riesterer",
    rating: 5,
    date: "2 years ago",
    quote:
      "Mitchell and Hero are both great! We have NEVER had a problem with our pool water. It is always crystal clear! Any mechanical issues are always fixed very quickly and very well. We never wanted a house with a pool due to the upkeep but with Tampa Bay Pool Pros we have the best of both worlds: a beautiful pool without ever worrying about maintaining it. Quick, professional, respectful, efficient, and affordable! Best decision we made as homeowners was to hire them. This is NOT a franchise with different people cycling through. This is a local business with a wonderful rapport and reputation. HIGHLY RECOMMEND!",
  },
  {
    name: "D Layne",
    rating: 5,
    date: "1 year ago",
    quote:
      "Mitchell at Tampa Bay Pool Pros is the most courteous and knowledgeable pool tech I've ever had. I've had my pool for over 24 years and will not go anywhere else from now on. Don't waste your time with big companies. I rate him excellent in all areas!",
  },
  {
    name: "Janis W",
    rating: 5,
    date: "9 months ago",
    quote:
      "I can't say enough about this company. Mitchell made my pool look great by cleaning salt buildup on my tiles and he improved rust spots on the bottom too. These were an eye sore and my old pool cleaner said those couldn't be cleaned.",
  },
  {
    name: "Lesley Summerlin",
    rating: 5,
    date: "3 years ago",
    quote:
      "Mitch is by far the most knowledgeable pool professional in Tampa. We hired Tampa Bay Pool Pros to take care of our pool after our last service stopped showing up. He's now been servicing our pool for over a year and we would definitely recommend Tampa Bay Pool Pros to everyone looking for a pool company.",
  },
];
